import React from 'react';
import { isSSR } from '@front10/utils';
import AirportIataCode from '../_components/AirportIataCode';

/**
 * Try again, execute when user clicked in try again link
 * @param {*} self
 */
const tryAgain = (self) => {
  const { showFilters } = self.props;

  const { errorLoadingHistograms, errorLoadingOrigin, errorLoadingDestination } = self.state;
  if (showFilters) {
    if (errorLoadingOrigin) {
      self.getAirports();
    }
    if (errorLoadingDestination) {
      self.getAirports('destination');
    }
  }
  if (errorLoadingHistograms) {
    self.getHistograms();
  }
};

/**
 * Use to render airports in locations selector
 * @param {*} self
 * @param {*} item
 */
const renderAirport = (self, item, locationProps = {}) => {
  const { showAirportIataCode } = self.props;
  const { listItem } = locationProps;
  return <AirportIataCode item={item} showAirportIataCode={showAirportIataCode} {...listItem} />;
};

const stopScroll = () => {
  window.scrollTo(0, 0);
};

function notifyFullMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-enter-full-screen', true, true);
  window.dispatchEvent(event);
}

function notifyExitFullMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-exit-full-screen', true, true);
  window.dispatchEvent(event);
}

/**
 * Use to view container in full mode
 */
const enterFullMode = (self) => {
  /* eslint-disable no-param-reassign */
  if (self.containerReference && !isSSR()) {
    notifyFullMode();
    if (!window.FR) {
      window.FR = {};
    }
    window.FR.scroll = { top: window.scrollY };
    window.addEventListener('scroll', stopScroll);
    const {
      containerReference: {
        style: { minHeight }
      }
    } = self;
    document.body.style.overflow = 'hidden';
    self.containerReference.style.position = 'fixed';
    self.containerReference.style.top = '0';
    self.containerReference.style.left = '0';
    self.containerReference.style.width = '100%';
    self.containerReference.style.height = '100%';
    self.containerReference.style.backgroundColor = 'white';
    self.containerReference.style.zIndex = '10000';
    self.containerReference.style.padding = '5px 15px';
    self.containerReference.style.minHeight = null;
    self.containerReference.style.overflowY = 'auto';
    self.containerReference.setAttribute('data-min-height', minHeight);
    self.containerReference.classList.remove('fr-position-relative');
  }
  /* eslint-enable no-param-reassign */
};

const exitFullMode = (self) => {
  /* eslint-disable no-param-reassign */
  if (self.containerReference && !isSSR()) {
    notifyExitFullMode();
    if (!window.FR) {
      window.FR = {};
    }
    if (!window.FR.scroll) {
      window.FR.scroll = { top: 0 };
    }
    window.removeEventListener('scroll', stopScroll);
    window.scrollTo(0, window.FR.scroll.top);
    const minHeight = self.containerReference.getAttribute('data-min-height');
    document.body.style.overflow = null;
    document.body.style.overflowY = null;
    self.containerReference.style.overflow = null;
    self.containerReference.style.position = null;
    self.containerReference.style.top = null;
    self.containerReference.style.left = null;
    self.containerReference.style.width = null;
    self.containerReference.style.height = null;
    self.containerReference.style.backgroundColor = null;
    self.containerReference.style.zIndex = null;
    self.containerReference.style.padding = null;
    self.containerReference.style.minHeight = minHeight;
    self.containerReference.classList.add('fr-position-relative');
  }
  /* eslint-enable no-param-reassign */
};

export { tryAgain, renderAirport, enterFullMode, exitFullMode };
